appSocial.component('favoritesList', {
    templateUrl: 'widgets/portfolio/components/favorites-list/FavoritesListComponent.html',
    bindings: {},
    controller: class FavoritesListComponent {
        constructor(
            $scope,
            SocialTypes,
            SocialLocaleService,
            SocialFavoriteService,
            SocialUserService,
            SocialUtils) {

            /**
             * @type {SocialFavoriteService}
             */
            this.favoriteService = SocialFavoriteService;
            /**
             * @type {SocialUserService}
             */
            this.userService = SocialUserService;

            this.utils = SocialUtils;

            this.translation = SocialLocaleService.translation;

            this.traders = [];

            this.watchFavorites = $scope.$on('SocialFavoriteService.change', () => {
                this.traders = this.favoriteService.traders;
            })
        }

        $onInit() {
            this.traders = this.favoriteService.traders;
            console.log('favorites:', this.traders);
        }

        $onChanges(changes) {

        }

        $onDestroy() {
            this.watchFavorites && this.watchFavorites();
        }

    }
});
